{
    "smartTasks": {
        "generate": {
            "focusApp": {
                "title": "アプリに焦点を当てる",
                "description": "生成されたテキストを表示したいアプリにフォーカスを合わせてください。「生成」をクリックすると、その場所にシームレスにテキストが生成されます。"
            }
        },
        "rewrite": {
            "focusApp": {
                "title": "アプリに焦点を当てる",
                "description": "書き換えたテキストを表示したいアプリにフォーカスを合わせてください。「生成」をクリックすると、その場所にシームレスにテキストが生成されます。"
            }
        }
    },
    "customControls": {
        "tourLabel": "常に利用可能なグローバルおよびデバイスコントロール",
        "rowDescription": "マイクがオンになっている場合、どのアプリを使用していても、グローバルコントロールとデバイスコントロールは常に利用できます。これらのコントロールを使えば、新しいアプリコントロールを作成することなくデバイスを操作できます。コントロールやアプリの切り替え、テキストの生成、マイクの一時停止など、便利なコマンドが含まれています。"
    },
    "profile": {
        "switch": {
            "title": "アプリのコントロールを切り替える",
            "description": "アプリの操作設定は、使用しているアプリに基づいて自動的に切り替わる場合もあれば、ここでいつでも手動で変更することもできます。"
        }
    },
    "dictation": {
        "tourLabel": "ディクテーション",
        "learn": "ディクテーション モードを使用して、ハンズフリーで音声をテキストに変換する方法を学びます。",
        "welcome": {
            "title": "ディクテーション",
            "description": "ディクテーションを使えば、自然な話し方で、話しながら入力できます。まるで、あなたの話す言葉をすべて入力してくれるパーソナルアシスタントがいるかのようです。"
        },
        "microphone": {
            "title": "マイクをオンにする",
            "description": "まず、マイクをオンにします。Cephableパネルのマイク切り替えボタンをクリックします。"
        },
        "activate": {
            "title": "ディクテーションモードを開始",
            "description": "音声はコマンドモードで起動します。ディクテーションを開始するには、「ディクテーションを開始」と言うか、ディクテーションボタンをクリックしてください。それでは、ディクテーションモードをオンにしましょう。"
        },
        "focus": {
            "title": "テキストフィールドまたはドキュメントにフォーカスする",
            "description": "ディクテーションは、テキストフィールドまたはドキュメントにフォーカスを当てると最も効果的に機能します。ディクテーションしたいテキストフィールドまたはドキュメントをクリックします。"
        },
        "speaking": {
            "title": "話し始める",
            "description": "さあ、話し始めましょう。話した内容はすべて、フォーカスしたテキストフィールドまたはドキュメントに入力されます。「こんにちは。ディクテーションモードのテストです」のように言ってみてください。"
        },
        "pauseResume": {
            "title": "ディクテーションの一時停止",
            "description": "ディクテーションを停止せずに休憩したい場合は、「ディクテーションを一時停止」と発声してください。「ディクテーションを開始」と発声すればいつでも再開できます。この機能は、常時オンのグローバルコントロールとデバイスコントロールでさらにカスタマイズできます。"
        },
        "stop": {
            "title": "ディクテーションをやめる",
            "description": "アプリのコントロールに戻りたいですか？「ディクテーションを停止」と言うだけです。これでディクテーションモードが停止し、コマンドモードに戻ります。「ディクテーションを開始」と言えばいつでも再開できます。"
        },
        "complete": {
            "description": "これで完了です！音声入力、一時停止、再開、そして音声入力モードとコマンドモードの切り替えができるようになりました。音声入力はハンズフリー入力を可能にする強力なツールです。メールや文書の作成など、音声入力が必要なあらゆる作業にお使いいただけます。"
        }
    },
    "microphone": {
        "tourLabel": "音声コントロール",
        "learn": "音声を使用して任意のアプリを制御し、ディクテーションを使用して話したことを入力する方法を学びます。",
        "rowDescription": "マイクがオフになっていると、音声コマンドは全く認識されません。しかし、オンにすると、一時停止や開始などの操作をグローバルコマンドで操作できるようになります。さあ、オンにしてみましょう。",
        "tryOpen": {
            "title": "「Spotify を開く」または「Word を開く」と言ってみてください"
        },
        "finishedCommands": {
            "title": "素晴らしい！音声コントロールの基本を学習しました。",
            "description": "サポートページからいつでもツアーを再開できます。次のステップはディクテーションについて学ぶことです。サポートページからツアーを開始できます。"
        }
    },
    "tour": {
        "startTour": "ツアーを開始",
        "finishTour": "ツアー終了",
        "statusDialog": "詳細についてはパネルをご確認ください。",
        "step": "{{step}} / {{total}} ステップ",
        "skipTour": "ツアーをスキップ"
    },
    "onboarding": {
        "overview": "概要",
        "learn": "Cephable の機能とその使用方法について学びます。",
        "start": "まだ始まったばかりのようですね。これから役立つヒントをいくつかご紹介します。",
        "dashboard": {
            "title": "Cephable Workspace",
            "description": "Cephable Workspaceは、デバイス、アプリのコントロール、および設定を管理するための中心的なハブです。ここから、エクスペリエンスをカスタマイズしたり、アクティブなコマンドを表示したり、Cephableのすべての機能にアクセスしたりできます。"
        },
        "step1": {
            "title": "Cephableへようこそ",
            "description": "Cephableは、あなたのパーソナルAIです。素早いアクション、音声コマンド、コンテンツ生成、そしてツール全体のスマートな自動化を実現します。すぐに使える操作性。クラウド処理は不要。あなたの移動に合わせて生産性を向上します。"
        },
        "finish": {
            "continueToApp": "Cephableダッシュボードに進む",
            "keepExploring": "探検を続ける"
        },
        "useCaseSlider": {
            "context": "使用したい",
            "control": "制御する"
        }
    },
    "support": {
        "description": "Cephable の使用方法に関する詳細情報（その他のツアー、ステップバイステップ ガイド、チュートリアル、ビデオなど）については、サポート ハブをご覧ください。",
        "title": "サポート"
    },
    "editingVideos": {
        "tourLabel": "動画編集の面倒なクリックではなく、ストーリーに集中しましょう",
        "learn": "音声コントロールと音声入力を使って動画編集をより速く行い、編集中にどのボタンをクリックするかを覚えるという認知負荷を軽減する方法を学びましょう。",
        "tryOpen": {
            "title": "「CapCutを開く」または「iMovieを開く」と言ってみてください。"
        },
        "complete": {
            "description": "これで、お気に入りの動画編集アプリで音声コマンドとクイックアクションを使って、再生、一時停止、トラックのスキップ、音量調整を行う方法がわかりました。さらにスムーズな動画操作のために、他のコマンドを試したり、独自のクイックアクションをカスタマイズしたりしてみましょう。"
        }
    },
    "congrats": "おめでとうございます！",
    "fpsGamePlay": {
        "tourLabel": "音声コントロールでFPSゲームをプレイ",
        "learn": "音声コントロールとクイックアクションを使用して FPS ゲームをプレイする方法を学びます。",
        "tryOpen": {
            "title": "「Valorantを開く」または「Battlefieldを開く」と言ってみてください"
        },
        "complete": {
            "description": "FPSゲームで音声コマンドとクイックアクションを使ってキャラクターを動かしたり、停止したり、操作する方法を習得しました。もっと多くのコマンドを試したり、クイックアクションをカスタマイズして、よりスムーズでスピーディーなゲームプレイを実現しましょう。"
        }
    },
    "redo": "オンボーディングをやり直す",
    "title": "Cephableについて",
    "description": "あなたのパーソナル AI アシスタントである Cephable を体験し、パーソナライズされたユースケースへの関心を共有しましょう。",
    "panel": {
        "description": "これはメインのコントロールセンターとなるパネルです。常に表示されており、音声を使ってアプリなどを操作できます。まずはマイクから始めましょう。"
    },
    "controlExpanded": {
        "tourLabel": "コントロール",
        "description": "アプリコントロールとは、特定のアプリケーションで使用できる設定済みの操作セットのことです。このセクションでは、音声コマンド、タップ、文字入力など、さまざまな方法で使用できるすべてのコントロールを紹介します。"
    },
    "submit": {
        "title": "提出する",
        "description": "コンテンツはカーソルがフォーカスしている場所に出力されます。"
    },
    "tryOpen": {
        "description": "`Open`は、指定したアプリを開いてフォーカスを移すグローバルコマンドです。自動コントロール切り替えが有効になっている場合は、使用中のアプリに最適なアプリコントロールに自動的に切り替わります。"
    },
    "modeSelector": {
        "title": "選択モード",
        "description": "利用可能な場合は、操作モードを選択できます。コマンドを送信するアプリには「コントロール」を、要約、書き換え、翻訳などの生成テキストコンテンツには「作成」を使用してください。デスクトップまたはアプリ間フローには「自動化」を選択してください。"
    },
    "contextSelector": {
        "title": "コンテキストを選択",
        "description": "可能であれば、私が操作するコンテキストを選択できます。例えば、クリップボードやハイライトされたテキストを使用したり、作業対象とするファイルやフォルダを添付したりできます。"
    },
    "panelInput": {
        "title": "私に何をしてほしいのですか？",
        "description": "私に何をしてほしいか、命令したり、入力したり、口述したりしてください。"
    },
    "figma": {
        "tourLabel": "FigmaとCanvaの音声コマンド",
        "learn": "Controlsの音声コントロール、音声マウス、音声入力、AIコンテンツ生成機能を活用して、デザインワークフローを改善する方法を学びましょう。",
        "complete": {
            "description": "これで、ワークフローを効率化するためのデザインの制御と作成方法がわかりました。さらにスムーズなデザイン制御のために、他のコマンドも試してみてください。"
        },
        "tryOpen": {
            "title": "「Figmaを開く」または「Canvaを開く」と言ってみてください。"
        }
    },
    "voiceMouse": {
        "title": "ボイスマウス",
        "description": "ボタンを名前でクリックするには、音声マウスを使用できます。「保存をタップ」または「設定へ移動」と言うことで使用できます。"
    },
    "documentSummary": {
        "tourLabel": "機密報告書からのチーム概要草稿",
        "learn": "部門レポートの自動読み込み、情報提供すべき適切な担当者の特定、メールの作成まで、すべてデバイス上で完結するため、機密データは安全に保護されます。",
        "congrats": {
            "description": "これで、AIワークフローを使用して機密文書を読み込み、チーム宛ての要約メールを作成する方法がわかりました。しかも、データがデバイスから外部に送信されることはありません。"
        }
    },
    "extensions": {
        "tourLabel": "拡張機能",
        "rowDescription": "Cephableを拡張して、デバイスを操作するためのより多くの方法を追加しましょう。例えば、顔や頭の動きを制御するカメラコントロールや、ゲームパッドのサポートなどです。必要な機能をここで有効にしてください。"
    },
    "developerBuildTests": {
        "tourLabel": "AIワークフローでビルドとテストを自動化する",
        "learn": "Cephableは、プロジェクトのビルドやテストの実行など、複数のステップからなるターミナルタスクを、デバイス上でバックグラウンドで完全に実行できるため、ユーザーは作業を続けることができます。",
        "complete": {
            "description": "これで、複数ステップのビルドおよびテストタスクを実行するためのデバイス内AIワークフローの実行方法、権限要求への対応方法、そして結果の反復的な改善方法がわかりました。別の反復的な開発タスクの自動化を試してみましょう。"
        }
    },
    "classroomStudyTools": {
        "tourLabel": "授業ノートや記事を学習ツールや教材に活用しよう",
        "learn": "Cephableは、音声入力、デバイス上での作成ツール、自動化機能などを通じて、教師と生徒をサポートします。これらはすべて、普段お使いのアプリ内で完結し、プライバシーを保護しながらデバイス上で完結します。",
        "complete": {
            "description": "これで、デバイス上で直接ドキュメントに音声入力する方法、メモから新しい学習教材を生成する方法、そしてAutomateを使用してバックグラウンドで完全な課題を作成する方法がわかりました。"
        }
    },
    "engineeringFlows": {
        "tourLabel": "開発者向け音声制御＋AI自動化",
        "learn": "音声制御による開発コマンド、独自のコードをコンテキストとして使用するAIリライト、そしてバックグラウンドで動作するAIワークフローなど、すべてデバイス上で実行できる機能を活用して、エンジニアリングワークフローを高速化する方法を学びましょう。",
        "tryOpen": {
            "title": "「Visual Studio Codeを開く」と言ってみてください。"
        },
        "complete": {
            "description": "これで、音声制御による開発コマンド、独自のコードをコンテキストとして使用するAI書き換え、およびバックグラウンドAIワークフローを使用して、エンジニアリングフローを高速化する方法がわかりました。"
        }
    },
    "meetingNotesToFiles": {
        "tourLabel": "会議の議事録を実用的なファイルに変換する",
        "learn": "Cephableを使えば、会議の議事録をより小さく、実用的なファイルに分割できるので、自分のペースで作業を進めることができます。しかも、すべてデバイス上で完結します。",
        "complete": {
            "description": "これで、AIワークフローを使用して会議の議事録をより小さな実行可能なファイルに分割し、AI履歴からいつでも会話を再開する方法がわかりました。"
        }
    },
    "notesToPresentation": {
        "tourLabel": "機密文書の要約とプレゼンテーションの作成をすべてデバイス上で行えます。",
        "learn": "Cephableは、機密性の高いレポートやメモを要約し、AIワークフローを使用してフォルダ内のファイル全体にわたって要約処理を行い、さらにその結果からプレゼンテーションを作成することもできます。これらの機能はすべてデバイス上で動作します。",
        "complete": {
            "description": "これで、機密文書の要約、AIワークフローを使用したフォルダ全体の一括要約、そしてその結果をプレゼンテーションに変換する方法がわかりました。しかも、これらの操作はすべて、データがデバイスから外部に漏れることなく行えます。"
        }
    },
    "organizeDownloads": {
        "tourLabel": "AIワークフローでファイルを整理し、不要なファイルを削除し、紛失したファイルを見つけ出そう",
        "learn": "Automateは、ファイルのコピー、削除、検索といった複数ステップのファイル管理タスクを、簡単なプロンプトから直接処理できます。",
        "complete": {
            "description": "これで、AIワークフローを使用してファイルを整理したり、権限チェックを行い安全にクリーンアップしたり、場所が思い出せないファイルを見つけたりする方法がわかりました。"
        }
    },
    "outlookEmailProductivity": {
        "tourLabel": "Outlookで音声入力、クイックアクション、AIを活用してメールの処理速度を向上させましょう",
        "learn": "Cephable PlusとProfessionalには、コンテンツの作成と編集に役立つインテリジェントな音声入力ツールと作成ツールが搭載されています。これらのツールをOutlook内で直接使用することで、メールの返信や下書きをより迅速に行うことができます。",
        "complete": {
            "description": "これで、音声入力でメールに返信する方法、独自のクイックタイプアクションを使用する方法、そして要約と生成機能を使ってメールコンテンツを作成・推敲する方法が、すべてデバイス上で操作できるようになりました。"
        }
    },
    "customizingGameControls": {
        "tourLabel": "音声操作でRPGゲームをプレイしよう",
        "learn": "音声操作とクイックアクションを使ってRPGゲームをプレイする方法を学びましょう。",
        "tryOpen": {
            "title": "「マインクラフトを開く」と言ってみてください。"
        },
        "complete": {
            "description": "これで、音声コマンドとクイックアクションを使ってRPGゲームでキャラクターを移動、停止、操作する方法がわかりました。さらにスムーズでスピーディーなゲームプレイのために、他のコマンドを試したり、独自のクイックアクションをカスタマイズしたりしてみましょう。"
        }
    },
    "voiceToTextSocialMedia": {
        "tourLabel": "LinkedIn、Slack、Discord向けの音声テキスト変換機能",
        "learn": "インテリジェント音声入力機能を使って自然な文章を作成し、その後書き換え機能でトーンを調整できます。LinkedIn、Slack、Discordなど、様々なプラットフォームで同様の操作が可能です。",
        "complete": {
            "description": "これで、LinkedIn、Slack、Discordなど、さまざまなプラットフォームでRewriteを使って投稿を音声入力し、推敲する方法がわかりました。"
        }
    },
    "aiDocumentTranslation": {
        "tourLabel": "デバイス上で文書を任意の言語に翻訳",
        "learn": "Cephableは、文書を一度に1つの言語に翻訳することも、AIワークフローを使用して複数の言語に同時に翻訳することもできます。これらはすべてローカルで実行されます。",
        "complete": {
            "description": "これで、音声入力を使って文書を単一の言語に翻訳する方法、あるいはAIワークフローを使って複数の言語に同時に翻訳する方法が分かりました。すべてデバイス上で完結します。"
        }
    },
    "excelAiAutomation": {
        "tourLabel": "プライベートなオンデバイスAIでスプレッドシートを分析",
        "learn": "Cephableは、Excelファイルを読み込み、数値に関する質問に答え、さらに詳細な分析を行うことができます。しかも、データがデバイスから外部に送信されることはありません。",
        "complete": {
            "description": "これで、AIワークフローを使用してスプレッドシートに質問したり、フォローアップでさらに深く掘り下げたり、要約を保存したりする方法を理解しました。これらすべてがデバイス上で実行されます。"
        }
    },
    "handsFreeComputerControl": {
        "tourLabel": "音声とカメラでコンピューターを操作する",
        "learn": "Cephableを使えば、音声コマンド、ボイスマウス、カメラを使った頭部や顔の制御によって、ハンズフリーでコンピューターを操作できます。",
        "tryOpenWord": {
            "title": "「Open Word」と言ってみてください。"
        },
        "openExtensions": {
            "title": "拡張機能タブを開く",
            "description": "カメラコントロールを有効にするには、メインウィンドウの「拡張機能」タブを開きます。"
        },
        "turnOnCamera": {
            "title": "カメラコントロールをオンにする",
            "description": "カメラをオンに切り替えてください。マイクアイコンの横にカメラアイコンが表示され、「設定」に新しい「カメラ」セクションが表示されます。"
        },
        "cameraInPanel": {
            "title": "パネル内のカメラコントロール",
            "description": "カメラコントロールが有効になると、Cephableパネルにもカメラの切り替えボタンが表示されます。Cephableが自動的にここでオンにします。"
        },
        "openCameraSettings": {
            "title": "カメラ設定を開く",
            "description": "カメラ設定を開いて、頭と顔の操作方法を細かく調整してください。"
        },
        "chooseHeadMouseMode": {
            "title": "ヘッドマウスモードを選択してください",
            "description": "頭の動きによるマウス操作方法を選択してください：安定グライド、スピードブースト、ダイナミックグライド。"
        },
        "complete": {
            "description": "これで、音声、音声マウス、カメラを使った頭や顔の認識による操作方法がわかりました。カメラ設定をさらに詳しく調べて、自分に合った操作方法を構築しましょう。"
        }
    },
    "handsFreeTypingDocumentCreation": {
        "tourLabel": "ハンズフリーでドキュメントを作成・編集",
        "learn": "生成、書き換え、音声コントロールを組み合わせて使用することで、請求書などの文書をほぼ完全にハンズフリーで作成および編集できます。",
        "complete": {
            "description": "これで、生成、書き換え、音声コマンドを使って、ほぼ完全にハンズフリーで文書を作成、書き換え、編集する方法がわかりました。"
        }
    },
    "webResearchCreateHtml": {
        "tourLabel": "ウェブを調査し、それをもとにサイトを構築する ― すべてデバイス上で完結",
        "learn": "Cephableは競合他社のウェブサイトを閲覧・分析し、その結果に基づいて新しいHTMLサイトを生成します。この処理はすべてデバイス上で行われるため、調査内容は非公開に保たれます。",
        "complete": {
            "description": "これで、AIワークフローを使用して競合他社のウェブサイトを調査し、その結果に基づいて新しいHTMLサイトを生成する方法がわかりました。しかも、これらの操作はすべて、データがデバイスから外部に送信されることなく行えます。"
        }
    },
    "webResearchSummarize": {
        "tourLabel": "規制を調査し、調査結果を要約する — すべてデバイス上で実施",
        "learn": "Cephableはウェブを閲覧して、新しいデータ保護法などの変更点を調査し、調査結果をチームが実行できる形で要約します。すべてデバイス上で行われるため、調査内容のプライバシーは保護されます。",
        "complete": {
            "description": "これで、AIワークフローを使用して規制変更を調査し、実装の詳細を掘り下げ、調査結果をチームが繰り返し検討できるメールとして作成する方法がわかりました。しかも、これらの操作はすべて、データがデバイスから外部に送信されることなく行えます。"
        }
    },
    "stopListening": {
        "title": "「聞くのをやめて」と言ってみてください。",
        "description": "これはマイクを完全にオフにすることなく、一時停止します。準備ができたら、もう一度「再生開始」と言ってください。"
    }
}
